import { render } from "./legoBox.vue?vue&type=template&id=4079cf14"
import script from "./legoBox.vue?vue&type=script&lang=js"
export * from "./legoBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoBox/legoBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4079cf14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4079cf14', __exports__)) {
    api.reload('4079cf14', __exports__)
  }
  
  module.hot.accept("./legoBox.vue?vue&type=template&id=4079cf14", () => {
    api.rerender('4079cf14', render)
  })

}


export default __exports__